import { useEffect } from 'react';
import { TeamTimeslotByDate } from '../utils/helpers';

interface SetDateKeysProps {
  allAvailableTimeslotsByDate: TeamTimeslotByDate | undefined;
  setSelectableDays: (value: string[]) => void;
  setAppointmentDate: (appointmentDate: string) => void;
}

export function useSetDateKeys({
  allAvailableTimeslotsByDate,
  setSelectableDays,
  setAppointmentDate,
}: SetDateKeysProps) {
  useEffect(() => {
    if (allAvailableTimeslotsByDate) {
      const dateKeys = Object.keys(allAvailableTimeslotsByDate);
      if (dateKeys) {
        setSelectableDays(dateKeys);
        setAppointmentDate(dateKeys[0]);
      }
    }
  }, [allAvailableTimeslotsByDate, setSelectableDays, setAppointmentDate]);
}

export default useSetDateKeys;
